export default __webpack_public_path__ + "images/8b862e987550743a29b085be4a827d78.png";